<template>
	<edit-template class="add-campus" @confirm="saveData" @cancel="cancelData" :cancelRemind="false" confirmText="保存" cancelText="取消">

		<div class="form-body">
			<el-form ref="form" :model="form" label-width="140rem">
				<el-form-item prop="school_name" label="校区名称" :rules="[
						{ required: true, message: '校区名称必填' },
						{ type: 'string', max: 20, message: '校区名称最多不能超过20个字符' }
					]" class="item">
					<el-input v-model="form.school_name" placeholder="请输入"></el-input>
				</el-form-item>
        <el-form-item prop="short_name" label="学校简称" :rules="[
						{ required: true, message: '学校简称必填' },
						{ type: 'string', max: 20, message: '学校简称最多不能超过20个字符' }
					]" class="item">
					<el-input v-model="form.short_name" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="校区地址" :rules="[{ required: true, message: '请选择校区地址' }]">
					<el-select :popper-append-to-body="false" v-model="form.province_id" placeholder="请选择省" class="select" @change="proveChange">
						<el-option v-for="item in proveData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
					-
					<el-select :popper-append-to-body="false" v-model="form.city_id" placeholder="请选择市" class="select" @change="cityChange">
						<el-option v-for="item in cityData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
					-
					<el-select :popper-append-to-body="false" v-model="form.area_id" placeholder="请选择区" class="select">
						<el-option v-for="item in areaData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="详细地址" prop="details" :rules="[{ required: true, message: '请输入详细地址' }]" class="item">
					<el-input v-model="form.details" placeholder="请输入详细地址" style="width: 540rem!important;" class="adressinput"></el-input>
				</el-form-item>
				<el-form-item label="建校时间" prop="school_time" :rules="[{ required: true, message: '请选择建校时间' }]" class="item">
					<el-date-picker v-model="form.school_time" type="date" placeholder="选择日期"> </el-date-picker>
				</el-form-item>
        <el-form-item label="校区负责人" prop="principal" :rules="[{ required: true, message: '请选择校区负责人' }]">
          <el-select v-model="form.principal" filterable="" remote="" reserve-keyword="" placeholder="请输入教职工姓名或手机号" :remote-method="handleRequest" :loading="loading" style="width: 15.069444vw !important">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请选择是否为实体校区' }]" label="是否为实体校区" prop="is_entity">
          <el-radio-group v-model="form.is_entity">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请选择是否咨询学校' }]" label="是否咨询学校" prop="is_consulting">
          <el-radio-group v-model="form.is_consulting">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请选择是否为可招聘校区' }]" label="是否为可招聘校区" prop="is_apply_position">
          <el-radio-group v-model="form.is_apply_position">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请输入学校编号' }]" label="学校编号" prop="school_no">
          <el-input v-model="form.school_no" placeholder="请输入学校编号"></el-input>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '请输入邮箱' }]" label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="校区类型" prop="school_type">
          <el-radio-group v-model="form.school_type">
            <el-radio :label="1">集团内校区</el-radio>
            <el-radio :label="2">合作机构</el-radio>
          </el-radio-group>
        </el-form-item>
			</el-form>
		</div>


</edit-template>
</template>

<script>
import {addCampus} from '@/api/campus'
import {get_2024government, getApi2} from '@/api'
import {changeOption} from "@/utils"

export default {
	_config:{"route":{"path":"add","meta":{"title":"新增"}}},
  data() {
		return {
      loading: false,
			options: [],
			form: {
				school_name: '',
        short_name: '',
				province_id: '',
				city_id: '',
				area_id: '',
				details: '',
				school_time: '',
				principal: '',
				is_apply_position: '',
        is_entity: '',
        is_consulting: '',
        school_type: 1
			},

			proveData: [],
			cityData: [],
			areaData: [],
			value: '',
			value1: '',
			value2: '',
			value3: ''
		}
	},
	methods: {
    handleRequest(keyword) {
      if (!keyword) return this.options = []
      this.loading = true;
      getApi2('/common/public/search-user' ,{ name: keyword }).then(res => {
        this.options = res.map(item => ({ label: item.teacher_name, value: item.id }))
      }).finally(() => this.loading = false)
    },
		// 获取省数据
		async getGovernment() {
			let res = await get_2024government({parent_code: '000000'})
			this.proveData = changeOption({list: res, label: 'address_name', value: 'address_code'})
		},
		proveChange(v) {
			this.cityData = []
			this.areaData = []
			this.getCityData()
			this.form.area_id = null
			this.form.city_id = null
		},

		// 获取市数据
		async getCityData() {
			let res = await get_2024government({ parent_code: this.form.province_id })
			this.cityData = changeOption({list: res, label: 'address_name', value: 'address_code'})
		},
		cityChange(v) {
			this.getAreaData()
			this.form.area_id = null
		},

		// 获取区数据
		async getAreaData() {
			let res = await get_2024government({ parent_code: this.form.city_id })
			this.areaData = changeOption({list: res, label: 'address_name', value: 'address_code'})
		},
		saveData() {
			//  验证
			let checkInputs = this.$tools.checkInputs
			let messageMap = {
				school_name: '校区名称',
				short_name: '学校简称',
				province_id: '省',
				city_id: '市',
				area_id: '区/县',
				details: '详细地址',
				school_time: '建校时间',
				principal: '校区负责人',
        is_entity: '是否为实体校区',
        is_consulting: '是否咨询学校',
        is_apply_position: '是否为可招聘校区',
				// phone: '负责人电话'
			}
			let checkOptions = []
			for (let k in this.form) {
				checkOptions.push({ type: 'empty', data: this.form[k], msg: messageMap[k] })
			}
			let flag = true
			checkInputs(checkOptions, (item, result) => {
				if (result) {
					let msg = item.msg + '不能为空'
					this.$message.warning(msg)
					flag = false
					throw msg
				}
			})
			if (!flag) return
			addCampus({ ...this.form }).then(res=>{
        let { error } = res.data
        if (error.errorCode == 1) {
          this.$message({
            type: 'error',
            message: error.errorUserMsg
          })
        } else if (error.errorCode == 0) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.$store.commit("setPage",1);
          this.$router.back();
        }
      }).catch(err=>{

      })
		},
		cancelData() {
			this.$confirm('是否取消新增', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.back()
			})
		}
	},
	created() {
		this.getGovernment()
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-select{
  width: 172rem;
  min-width: 172rem;
  .el-input{
    min-width: 172rem !important;
  }
}
</style>
